import { lazy, type ComponentType } from "react";

/**
 * Trang tai LUOI (code-splitting): moi slice thanh mot chunk rieng, trinh duyet chi tai
 * khi mo trang do lan dau. Cac trang cung slice dung chung mot lan import (mot chunk).
 *
 * Dang `lazy(() => import(...).then(m => ({ default: m.X })))` vi slice xuat ten (named export).
 */

function tu<M, K extends keyof M>(load: () => Promise<M>, key: K) {
  return lazy(() => load().then((m) => ({ default: m[key] as unknown as ComponentType<any> }))) as unknown as M[K];
}

const load_finance_cashflow = () => import("../pages/finance/cashflow");
export const TransactionListPage = tu(load_finance_cashflow, "TransactionListPage");
export const MonthlySummaryPage = tu(load_finance_cashflow, "MonthlySummaryPage");
export const DailyRevenuePage = tu(load_finance_cashflow, "DailyRevenuePage");
export const StoreRevenuePage = tu(load_finance_cashflow, "StoreRevenuePage");
export const BankHistoryPage = tu(load_finance_cashflow, "BankHistoryPage");

const load_finance_disbursement = () => import("../pages/finance/disbursement");
export const PlanListPage = tu(load_finance_disbursement, "PlanListPage");
export const PlanDetailPage = tu(load_finance_disbursement, "PlanDetailPage");
export const InterestPeriodsPage = tu(load_finance_disbursement, "InterestPeriodsPage");
export const BankConfigPage = tu(load_finance_disbursement, "BankConfigPage");

const load_finance_cash_qr = () => import("../pages/finance/cash-qr");
export const StoreCashQrPage = tu(load_finance_cash_qr, "StoreCashQrPage");
export const CashDepositsPage = tu(load_finance_cash_qr, "CashDepositsPage");
export const MappingPage = tu(load_finance_cash_qr, "MappingPage");

const load_system_auditlog = () => import("../pages/system/auditlog");
export const AuditLogPage = tu(load_system_auditlog, "AuditLogPage");

const load_hr = () => import("../pages/hr");
export const EmployeeListPage = tu(load_hr, "EmployeeListPage");
export const EmployeeDetailPage = tu(load_hr, "EmployeeDetailPage");
export const AccountListPage = tu(load_hr, "AccountListPage");

const load_system_rbac = () => import("../pages/system/rbac");
export const RoleListPage = tu(load_system_rbac, "RoleListPage");
export const UserPermissionPage = tu(load_system_rbac, "UserPermissionPage");

const load_nhanhvn = () => import("../pages/nhanhvn");
export const MohReportPage = tu(load_nhanhvn, "MohReportPage");
export const MohValuePage = tu(load_nhanhvn, "MohValuePage");
export const BestsellerPage = tu(load_nhanhvn, "BestsellerPage");
export const ProductAnalyticsPage = tu(load_nhanhvn, "ProductAnalyticsPage");
export const CustomerAnalyticsPage = tu(load_nhanhvn, "CustomerAnalyticsPage");
export const ProductionDashboardPage = tu(load_nhanhvn, "ProductionDashboardPage");
export const ProductionDetailPage = tu(load_nhanhvn, "ProductionDetailPage");
export const KeHoachHangHoaPage = tu(load_nhanhvn, "KeHoachHangHoaPage");
export const TargetCategoryPage = tu(load_nhanhvn, "TargetCategoryPage");
export const RestockPage = tu(load_nhanhvn, "RestockPage");
export const SalesPivotPage = tu(load_nhanhvn, "SalesPivotPage");
export const MonthlyReportPage = tu(load_nhanhvn, "MonthlyReportPage");
export const MonthlyProductPage = tu(load_nhanhvn, "MonthlyProductPage");
export const BillListPage = tu(load_nhanhvn, "BillListPage");
export const ProductConfigPage = tu(load_nhanhvn, "ProductConfigPage");
export const ProductRecodePage = tu(load_nhanhvn, "ProductRecodePage");
export const FirstSalePage = tu(load_nhanhvn, "FirstSalePage");
export const ProductionLarkPage = tu(load_nhanhvn, "ProductionLarkPage");
export const ChinaOrderPage = tu(load_nhanhvn, "ChinaOrderPage");
export const AllocationPage = tu(load_nhanhvn, "AllocationPage");
export const ShopeeAllocPage = tu(load_nhanhvn, "ShopeeAllocPage");
export const ImportAllocPage = tu(load_nhanhvn, "ImportAllocPage");
export const ImportReceiptsPage = tu(load_nhanhvn, "ImportReceiptsPage");
export const TargetV3Page = tu(load_nhanhvn, "TargetV3Page");
export const MtTransferPage = tu(load_nhanhvn, "MtTransferPage");
export const BagLookupPage = tu(load_nhanhvn, "BagLookupPage");
export const NhanhvnEntry = tu(load_nhanhvn, "NhanhvnEntry");

const load_shift = () => import("../pages/shift");
export const ShiftCalendarPage = tu(load_shift, "ShiftCalendarPage");

const load_me = () => import("../pages/me");
export const ProfilePage = tu(load_me, "ProfilePage");
export const UiSettingsPage = tu(load_me, "UiSettingsPage");

const load_facebook = () => import("../pages/facebook");
export const FacebookPage = tu(load_facebook, "FacebookPage");

const load_cskh = () => import("../pages/cskh");
export const CskhDashboardPage = tu(load_cskh, "CskhDashboardPage");
export const CskhKpiPage = tu(load_cskh, "CskhKpiPage");
export const CskhOperationsPage = tu(load_cskh, "CskhOperationsPage");

const load_thht = () => import("../pages/thht");
export const ThhtListPage = tu(load_thht, "ThhtListPage");
export const ThhtDashboardPage = tu(load_thht, "ThhtDashboardPage");
export const ThhtReportPage = tu(load_thht, "ThhtReportPage");

const load_kol = () => import("../pages/kol");
export const KolKocListPage = tu(load_kol, "KolKocListPage");
export const KolCampaignListPage = tu(load_kol, "KolCampaignListPage");
export const KolCampaignDetailPage = tu(load_kol, "KolCampaignDetailPage");
export const KolReportKocPage = tu(load_kol, "KolReportKocPage");
export const KolReportDailyPage = tu(load_kol, "KolReportDailyPage");
export const KolReportLatePostPage = tu(load_kol, "KolReportLatePostPage");
export const KolReportCostPage = tu(load_kol, "KolReportCostPage");
export const KolReportVideoPage = tu(load_kol, "KolReportVideoPage");
export const KolReportAllVideosPage = tu(load_kol, "KolReportAllVideosPage");
export const KolProvinceSummaryPage = tu(load_kol, "KolProvinceSummaryPage");
export const KolCampaignPerformancePage = tu(load_kol, "KolCampaignPerformancePage");

const load_system_admin = () => import("../pages/system/admin");
export const AdminIndexPage = tu(load_system_admin, "AdminIndexPage");
export const AdminModelPage = tu(load_system_admin, "AdminModelPage");
export const AdminRowPage = tu(load_system_admin, "AdminRowPage");

const load_shipping_weight = () => import("../pages/shipping-weight");
export const ShippingWeightPage = tu(load_shipping_weight, "ShippingWeightPage");

const load_voucher = () => import("../pages/voucher");
export const VoucherCampaignDetailPage = tu(load_voucher, "VoucherCampaignDetailPage");
export const VoucherPage = tu(load_voucher, "VoucherPage");
export const VoucherPublicPage = tu(load_voucher, "VoucherPublicPage");
export const VoucherPublicResultPage = tu(load_voucher, "VoucherPublicResultPage");

const load_tiktok = () => import("../pages/tiktok");
export const TiktokPage = tu(load_tiktok, "TiktokPage");

const load_tmdt = () => import("../pages/tmdt");
export const TmdtHomePage = tu(load_tmdt, "TmdtHomePage");

const load_auth_login = () => import("../pages/auth/login");
export const LoginPage = tu(load_auth_login, "LoginPage");

const load_portal = () => import("../pages/portal");
export const PortalPage = tu(load_portal, "PortalPage");

const load_auth_access = () => import("../pages/auth/access");
export const ForbiddenPage = tu(load_auth_access, "ForbiddenPage");
export const LogoutPage = tu(load_auth_access, "LogoutPage");

